<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button (click)="back()"></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ 'INBOX.SETTINGS.MESSAGE_TEMPLATES.EDIT_TEMPLATE' | translate }}</glxy-page-title>
    <glxy-page-actions>
      <button mat-stroked-button data-testid="cancel-button" (click)="back()">{{ 'INBOX.CANCEL' | translate }}</button>
      <button mat-flat-button color="primary" data-testid="save-button" (click)="edit()">
        {{ 'INBOX.SAVE' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <glxy-page-wrapper>
    <sms-builder
      [setMessageBuilderText]="this.inputMessageBuilderText$ | async"
      (sms)="outputMessageBuilderText = $event"
      (valid)="isValid = $event"
    ></sms-builder>
  </glxy-page-wrapper>
</glxy-page>
